module.exports = __webpack_public_path__ + "img/JoseChavarria.7379a761.png";